import { render, staticRenderFns } from "./CreateMallGoods.vue?vue&type=template&id=431f1f72&scoped=true"
import script from "./CreateMallGoods.vue?vue&type=script&lang=js"
export * from "./CreateMallGoods.vue?vue&type=script&lang=js"
import style0 from "./CreateMallGoods.vue?vue&type=style&index=0&id=431f1f72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431f1f72",
  null
  
)

export default component.exports